import React from "react";
import SeoHead from "./SeoHead";

const ArticleSeoHead = (props) => {
  const { article } = props;

  return (
    <SeoHead
      title={article.metadataTitle ? article.metadataTitle : article.title}
      description={article.metadataDescription ? article.metadataDescription : article.short}
      keywords={article.keywords}
      author={article.author}
      ogLocale={article.locale}
      ogImage={article.images[0].uri}
      ogImageWidth={600}
      ogTitle={article.title}
      ogDescription={article.short}
      schema={`{
        "@context": "https://schema.org",
        "@type": "Article",
        "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": "https://thecycleverse.com"
        },
        "headline": "${article.title}",
        "description": "${article.short}",
        "image": "${article.images[0].uri}",
        "author": {
            "@type": "Person",
            "name": "${article.author}"
        },  
        "publisher": {
            "@type": "Organization",
            "name": "The Cycleverse",
            "logo": {
            "@type": "ImageObject",
            "url": "https://thecycleverse.com/images/TheCycleverse.png",
            "width": "351",
            "height": "60"
            }
        },
        "datePublished": "${new Date(article.releaseTimestamp * 1000).toISOString()}",
        "dateModified": "${new Date(article.updatedAt).toISOString()}"
      }`}
    />
  );
};

export default ArticleSeoHead;
